<template>
  <div class="">
    <div class="is-border-top is-border-right is-border-left">
      <div v-if="!canSubmitDossierResa" class="notification is-danger has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-exclamation-circle"></i></span>
          <span class="has-text-weight-medium">INFORMATIONS ET fichiers MANQUANTS</span><span v-if="currentUserCountry === 'FRA'"> : impossible de générer le
          dossier de réservation</span>
        </p>
      </div>
      <div v-if="!canSubmitDossierResa" class="notification is-warning is-marginless is-min-height-75 is-flex">
        <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
          Vous devez vérifier et/ou completer les informations manqantes.<br>
          Les informations manquantes sont précédées de cette icone
          <span class="icon is-small has-text-danger"><i class="fas fa-check-circle"></i></span>
          dans les rubriques suivantes
        </div>
      </div>
      <div v-if="canSubmitDossierResa && !loadContrat" class="notification is-success has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
          <span class="icon"><i class="fas fa-check-square"></i></span>
          <span class="has-text-weight-medium">DOSSIER COMPLET</span><span v-if="currentUserCountry === 'FRA'"> : vous pouvez visualiser le dossier de réservation</span>
        </p>
      </div>
      <div v-if='canSubmitDossierResa && loadContrat' class="notification is-warning has-text-centered is-marginless">
        <p class="is-uppercase is-size-7">
           <span class="icon has-text-danger"><i class="fas fa-exclamation-triangle"></i></span>
          Attention, cette opération peut prendre quelques minutes
        </p>
      </div>
      <div class="columns is-centered is-4 is-gapless has-bg-white is-border">
        <div class="column is-flex is-narrow is-padding-top is-padding-left is-padding-bottom">
          <div class="has-badgeCustom--topright has-badgeCustom--out-quarter">
            <i class="fal fa-6x fa-file-pdf"></i>
            <span v-if='!canSubmitDossierResa'
                  class="badgeCustom is-large is-bordered is-danger tooltip is-tooltip-top"
                  data-tooltip="Information manquante">
              <span class="icon"><i class="fas fa-exclamation"></i></span>
            </span>
            <span v-else-if="canSubmitDossierResa && loadContrat" class="badgeCustom is-large is-bordered is-success tooltip is-tooltip-top"
                  data-tooltip="Génération en cours de traitement">
              <span class="icon"><i class="fas fa-clock"></i></span>
            </span>
            <span v-else class="badgeCustom is-large is-bordered is-success tooltip is-tooltip-top"
                  data-tooltip="Dossier complet">
              <span class="icon"><i class="fas fa-check"></i></span>
            </span>
          </div>
        </div>
        <div class="column is-self-centered is-narrow is-padding-top is-padding-left is-padding-bottom">
          <div>
            <span class="title is-3" style="font-weight: 500;">Contrat de réservation ADV {{adv.ref}}</span>
          </div>
          <div v-if="currentUserCountry === 'FRA'" class="column is-narrow is-padding-top-small is-paddingless-left is-paddingless-bottom is-padding-right-xlarge is-margin-right-xlarge">
            <div v-if='loadContrat && canSubmitDossierResa && !pendingEdition'>
              <button :disabled="true"
                        class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
                  <span class=""><span><i class="fas fa-spinner fa-spin is-margin-xsmall"></i></span> Génération en cours de traitement</span>
              </button>
            </div>
            <div v-else-if='canSubmitDossierResa && !pendingEdition'>
              <button @click="openModalDossierDeResa(contratDeResa)"
                        class="button is-small is-success is-transform-none is-fullwidth is-radius">
                  <span class="">visualiser contrat</span>
              </button>
            </div>
            <div v-else>
              <button :disabled="true"
                      class="button is-small is-light is-border is-transform-none is-fullwidth is-radius">
                <span class="">visualisation impossible</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-gapless has-bg-white is-min-height-64 is-border-top">
        <div class="column is-narrow is-flex is-padding-small"
             :class="!programChecked ? 'has-bg-danger': 'has-bg-success'">
          <span class="icon has-text-white is-self-centered"><i class="fas"
                                                                :class="!programChecked ? 'fa-exclamation-circle': 'fa-check-circle'"></i></span>
        </div>
        <div class="column is-self-centered is-padding-left">
          <div class="title is-4">Informations Programme</div>
          <div v-if="!programChecked" class="subtitle is-6 has-text-danger">Informations manquantes</div>
        </div>
        <div v-if="isAdmin" class="actionsOnRow actionsOnRow--vertical">
          <div class="is-min-height-full"><!-- seulement à ajouter quand il y a un seul élément-->
            <button @click="goToProgram()" class="tooltip is-tooltip-left" data-tooltip="Modifier la fiche programme">
              <span class="icon"><i class="fal fa-file-edit"></i></span>
            </button>
          </div>
        </div>
      </div>
      <div class="columns is-gapless has-bg-white is-min-height-64 is-border-top">
        <div class="column is-narrow is-flex is-padding-small" :class="!lotChecked ? 'has-bg-danger': 'has-bg-success'">
          <span class="icon has-text-white is-self-centered"><i class="fas"
                                                                :class="!lotChecked ? 'fa-exclamation-circle': 'fa-check-circle'"></i></span>
        </div>
        <div class="column is-self-centered is-padding-left">
          <div class="title is-4">Informations Lot</div>
          <div v-if="!lotChecked" class="subtitle is-6 has-text-danger">Informations manquantes</div>
        </div>
        <div v-if="isAdmin" class="actionsOnRow actionsOnRow--vertical">
          <div class="is-min-height-full"><!-- seulement à ajouter quand il y a un seul élément-->
            <button @click="goToLot()" class="tooltip is-tooltip-left" data-tooltip="Modifier la fiche lot">
              <span class="icon"><i class="fal fa-file-edit"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="has-bg-white is-border">
      <membre-adv @goToContact="goToContact" :is-check="checkCompleteBuyerMxn(buyer)" :membre="buyer" :is-promoteur="false" :is-co-acquereur="false" :modal-promoteur="false"></membre-adv>
      <template v-for="coBuyer in coBuyers">
        <membre-adv @goToContact="goToContact" @DeleteCobuyer="beforeRemove" :is-check="checkCompleteBuyerMxn(coBuyer)" :key="coBuyer.pk" :membre="coBuyer" :is-promoteur="false" :is-co-acquereur="true" :modal-promoteur="false"></membre-adv>
      </template>
      <membre-adv @openModalPromoteurInfo="openModalPromoteurInfo" :is-check="promoteurChecked" :membre="adv.promoteur_contact" :has-button="isAdmin || isSectorManager" :is-promoteur="true" :is-co-acquereur="false" :modal-promoteur="true"></membre-adv>
    </div>
    <div class="has-bg-white is-margin-top-xsmall is-border">
      <div class="columns is-gapless has-bg-white is-min-height-64 is-border-bottom" style="min-height: 65px;">
        <div class="column is-narrow is-flex is-padding-small"
          :class="financementChecked ? 'has-bg-success' : 'has-bg-danger'"
        >
          <span class="icon has-text-white is-self-centered">
            <i class="fas"
               :class="financementChecked ? 'fa-check-circle' : ' fa-exclamation-circle'">
            </i></span>
        </div>
        <div class="column is-self-centered is-padding-left">
          <div class="title is-4">Financement</div>
        </div>
      </div>
      <div class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-min-height-50"
           :class="!not_using_loan ? 'is-border-top has-bg-light is-border-left is-border-right ' : 'has-bg-dark'">
        <div class="column is-narrow">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
            <div>
              <input id="not_using_loan" v-model="not_using_loan" name="not_using_loan"
                     class="switch is-success is-rounded" type="checkbox">
              <label for="not_using_loan" style="font-size: 12.5px" :class="!not_using_loan ? '' : 'has-text-white'"
                     class="is-uppercase">Le réservataire déclare ne pas recourir à un ou plusieurs prêt
                bancaire</label>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-min-height-50"
           :class="!adv.security_deposit ? 'is-border-top has-bg-light is-border-left is-border-right ' : 'has-bg-dark'">
        <div class="column is-narrow">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall is-padding-right">
            <div>
              <input id="security_deposit" v-model="adv.security_deposit" @input="updateDeposit" name="security_deposit"
                     class="switch is-success is-rounded" type="checkbox">
              <label for="security_deposit" :class="!adv.security_deposit ? '' : 'has-text-white'"
                     style="font-size: 12.5px" class="is-uppercase">Dépot de garantie déposé à la signature</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="adv.security_deposit"
           class="is-padding-xsmall notification is-warning columns is-12 is-gapless is-padding-left-small is-padding-right-small is-vcentered is-min-height-50">
        <div class="column is-narrow is-8 is-padding-left-small">
          <div class="is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase is-size-7 has-text-weight-medium">Merci de préciser le montant du dépot de garantie déposé à la signature du contrat de réservation</span>
          </div>
        </div>
        <div class="column is-narrow is-3 is-padding-left-large">
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-min-width-0 is-square">
                <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input id="deposit_value" name="deposit_value" @input="val => updateSecurytyDeposit(val)"
                       :model="deposit_value" class=""
                       v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number='true'
                       input-type="number"
                       data-vv-as="">
              </v-input>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!not_using_loan" class="columns is-multiline is-border-top is-padding-bottom">
        <div class="column is-gapless is-paddingless is-12 columns is-multiline">
          <div class="column is-6 is-padding-left is-padding-right is-padding-top">
            <r-label :label="'Organisme bancaire'" :redCheck='true' :value="adv.initial_bank_name"></r-label>
            <v-input id="initial_bank_name" name="initial_bank_name" @input="val => updateBanqueValue(val)"
                     :model="adv.initial_bank_name"
                     data-vv-as="Organisme bancaire"
                     v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val">
            </v-input>
          </div>
        </div>
      </div>
      <div v-if="!not_using_loan" class="columns is-multiline is-padding-bottom">
        <div class="column is-gapless is-paddingless is-12 columns is-multiline">
          <div class="column is-4 is-padding-left is-padding-right is-padding-top">
            <r-label :label="'MONTANT MAXIMUM À EMPRUNTER'" :value="loan_value" :redCheck='true'></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-min-width-0 is-square">
                  <span class="icon"><i :class="`fas fa-${$faCurrency}-sign`"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input id="initial_loan_value" name="initial_loan_value" @input="val => updateLoanValue(val)"
                         :model="loan_value" class=""
                         v-validate="'decimal:2'" :errors-bag="errors" data-vv-value-path="val" :number='true'
                         input-type="number"
                         data-vv-as="MONTANT MAXIMUM À EMPRUNTER">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-3 is-padding-left is-padding-right is-padding-top">
            <r-label :label="'DURÉE maximale du prêt'" :value="adv.initial_loan_duration"
                     :redCheck='true'></r-label>
            <div class="field has-addons">
              <div class="control">
                <a class="button is-static is-border is-min-width-0 is-square">
                  <span class="icon"><i class="far fa-clock"></i></span>
                </a>
              </div>
              <div class="control is-expanded">
                <v-input id="initial_loan_duration" name="initial_loan_duration" @input="val => updateLoanDuration(val)"
                         :model="adv.initial_loan_duration"
                         :placeholder="'en année'"
                         data-vv-as="DURÉE maximale du prêt"
                         v-validate="'min:1'" :errors-bag="errors" data-vv-value-path="val">
                </v-input>
              </div>
            </div>
          </div>
          <div class="column is-3 is-padding-left is-padding-right is-padding-top">
            <r-label :label="`taux d’interêt maximum`" :redCheck='true' :value="loan_rate"></r-label>
            <div class="field has-addons is-marginless-bottom">
              <div class="control"><a class="button is-square is-static is-border is-min-width-0"><span class="icon"><i
                class="fas fa-percent"></i></span></a></div>
              <div class="control is-expanded">
                <input name="taux_com" v-model.number="loan_rate"
                       :max="100" @input="updateLoanRate()"
                       class="input" :step="0.1" type="number"
                       data-type-cy="input" data-value-cy="loan_rate">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="has-bg-white is-margin-top-xsmall is-border">
      <div class="columns is-gapless has-bg-white is-min-height-64 is-border-bottom" style="min-height: 65px;">
        <div class="column is-narrow is-flex is-padding-small"
             :class="documentChecked ? 'has-bg-success' : 'has-bg-danger'">
          <span class="icon has-text-white is-self-centered">
            <i class="fas"
               :class="documentChecked ? 'fa-check-circle' : ' fa-exclamation-circle'">
            </i></span>
        </div>
        <div class="column is-self-centered is-padding-left">
          <div class="title is-4">Documents annexés</div>
        </div>
      </div>
      <div
        class="is-padding-left is-padding-right is-padding-top-xsmall is-padding-bottom-xsmall is-min-height-50 is-flex"
        :class="!(isAdmin || isSectorManager) || documentChecked ? 'is-border-bottom' : ''">
        <div class="is-self-centered"><span class="is-uppercase title is-6">Liste des documents attendus en annexe</span>
        </div>
      </div>
      <div v-if="(isAdmin || isSectorManager) && !documentChecked" class="notification is-warning is-marginless is-min-height-75 is-flex">
        <div class="is-self-centered w100 is-uppercase is-size-7 has-text-weight-medium">
          Tous les documents ci-dessous doivent être téléchargés pour être annexés au contrat de réservation.<br>
          L'icône <span class="icon is-small has-text-success"><i class="fas fa-check-circle"></i></span> signale que le
          fichier téléchargé est correctement lié.
        </div>
      </div>
      <div id="document-list-item"
           :class="!(isAdmin || isSectorManager) || documentChecked ? 'is-margin-bottom is-margin-right is-margin-left is-border-bottom is-border-left is-border-right' : 'is-margin is-border'">
        <div v-dragula="contratDeReservationDocuments" drake="one" v-if='isAdmin || isSectorManager'>
          <document-list-item v-for="(doc, idx) in contratDeReservationDocuments"
                              :source="doc"
                              :all-documents="allDocuments"
                              :key="doc.value + '-document'"
                              :index="idx"
                              :canDrag="isAdmin || isSectorManager"
                              :selected-row="selectedRow"
                              @selectedRow="val => selectedRow = val"
                              @update="commitAdv"
                              @remove="removeContratDocument">
          </document-list-item>
        </div>
        <div v-if="!(isAdmin || isSectorManager)">
          <document-list-item v-for="(doc, idx) in contratDeReservationDocuments"
                              :source="doc"
                              :all-documents="allDocuments"
                              :key="doc.value + '-document'"
                              :index="idx"
                              :canDrag="isAdmin || isSectorManager"
                              :selected-row="selectedRow"
                              @selectedRow="val => selectedRow = val"
                              @update="commitAdv"
                              @remove="removeContratDocument">
          </document-list-item>
        </div>
        <div class="row-width-actions-bar" v-if="isAdmin || isSectorManager">
          <button class="page-header-btn button is-grey-dark is-fullwidth is-radiusless" @click="addNewAnnexDocument">
            <span>Ajouter un document à la liste</span>
          </button>
        </div>
      </div>
      <!-- <div v-if="canSubmitDossierResa && !pendingEdition"
           class="columns is-gapless is-centered has-bg-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-margin-left-small">
          <a @click="openModalDossierDeResa()"
             class="is-min-height-50 button is-success is-transform-none is-fullwidth">
            <div class="veryFastAnimation">
              <span>Afficher contrat de réservation</span>
            </div>
          </a>
        </div>
      </div> -->
      <div class="has-bg-white is-border is-margin-top-xxsmall">
        <div class="row-width-actions-bar columns is-gapless">
          <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
            <span class="is-uppercase title is-6">Commentaire</span>
          </div>
          <div class="column is-narrow is-border-left">
            <button class="page-header-btn is-small is-square" @click="openComment = !openComment"><span
              class="icon is-size-4">
              <i v-if="!openComment" class="fal fa-chevron-down"></i>
              <i v-else class="fal fa-chevron-up"></i>
              </span></button>
          </div>
        </div>
        <template v-if="openComment">
          <div v-if="!openWysi" class="vadDiscussion is-border-top">
            <div
              class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
              <div class="content" v-if="(isAdmin || isSectorManager) && adv.contrat_de_reservation.comment" v-html="adv.contrat_de_reservation.comment"></div>
              <div class="content" v-else-if="!(isAdmin || isSectorManager) && adv.contrat_de_reservation.seller_comment" v-html="adv.contrat_de_reservation.seller_comment"></div>
              <div class="content" v-else>Aucun commentaire</div>
              <div class="actionsOnRow actionsOnRow--vertical">
                <div class="">
                  <button @click="openWysiwyg()" class="is-min-height-full">
                    <span class="icon is-small"><i class="fal fa-edit"></i></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="is-border-top columns is-gapless">
            <div class="column" v-if="isAdmin || isSectorManager">
              <wysiwyg-editor
                :light='true' :tooltip-top="true"
                :model="commentaire"
                @change="val => commentaire = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="column" v-else>
              <wysiwyg-editor
                :light='true' :tooltip-top="true"
                :model="seller_commentaire"
                @change="val => seller_commentaire = val"
                class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
              </wysiwyg-editor>
            </div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div>
                <button @click="saveAdv()" type="button" class="button is-success">
                  <span class="icon is-small"><i class="fal fa-save"></i></span>
                </button>
              </div>
              <div class="">
                <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
                  <span class="icon is-small"><i class="fal fa-times"></i></span>
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { AdvMx } from '@/mixins'
  import { isNil, isEmpty, debounce, remove, cloneDeep } from 'lodash'
  import moment from 'moment'
  import { mapState, mapGetters } from 'vuex'
  import { bus, EVENTS } from '@/services/bus/index.js'
  import MembreAdv from '../MembreAdv'

  import DocumentListItem from '../DocumentListItem'

  const uuidv4 = require('uuid/v4')

  export default {
    name: 'ContratDeReservation',
    mixins: [AdvMx],
    components: { DocumentListItem, MembreAdv },
    data () {
      return {
        loadContrat: false,
        openWysi: false,
        commentaire: null,
        seller_commentaire: null,
        openComment: true,
        not_using_loan: false,
        loan_value: null,
        loan_rate: null,
        deposit_value: null,
        loadingContrat: false,
        reservationDate: null,
        debutDeVenteAnnoncee: null,
        accuseDeReception: [],
        annexesDocuments: []
      }
    },
    computed: {
      ...mapState(['quickview', 'modal', 'contratDeResa']),
      ...mapGetters(['isSeller', 'isExternal', 'currentUserCountry']),
      url () {
        const apiUrl = this.$configs.APIROOT
        return apiUrl + '/pdf/dossier-de-reservation/' + this.advPk + '.pdf'
      },
      programChecked () {
        if (!this.program) return
        if (this.currentUserCountry === 'FRA') {
          return (this.program.total_lots !== null && this.program.total_lots !== '') &&
            (this.program.reference_cadrastrale !== null && this.program.reference_cadrastrale !== '') &&
            (this.program.surface_terrain !== null && this.program.surface_terrain !== '') &&
            (this.program.surface_plancher !== null && this.program.surface_plancher !== '') &&
            (this.program.num_pc !== null && this.program.num_pc !== '') &&
            (this.program.total_parking !== null && this.program.total_parking !== '') &&
            (this.program.planned_developments !== null && this.program.planned_developments !== '') &&
            (this.program.construction_licence_author !== null && this.program.construction_licence_author !== '') &&
            (this.program.construction_licence_date !== null && this.program.construction_licence_date !== '') &&
            (this.program.total_buildings !== null && this.program.total_buildings !== '') &&
            (this.program.promoteur_info.rep_first_name !== null && this.program.promoteur_info.rep_first_name !== '') &&
            (this.program.promoteur_info.rep_last_name !== null && this.program.promoteur_info.rep_last_name !== '') &&
            (this.program.promoteur_info.rep_email !== null && this.program.promoteur_info.rep_email !== '') &&
            (this.program.promoteur_info.rep_phone !== null && this.program.promoteur_info.rep_phone !== '') &&
            (this.program.promoteur_info.rep_address !== null && this.program.promoteur_info.rep_address !== '') &&
            (this.program.promoteur_info.rep_address.line1 !== null && this.program.promoteur_info.rep_address.line1 !== '') &&
            (this.program.promoteur_info.rep_address.city !== null && this.program.promoteur_info.rep_address.city !== '') &&
            (this.program.promoteur_info.rep_address.country !== null && this.program.promoteur_info.rep_address.country !== '') &&
            (this.program.promoteur_info.rep_address.zip_code !== null && this.program.promoteur_info.rep_address.zip_code !== '') &&
            (this.program.ref !== null && this.program.ref !== '') &&
            (this.program.notary.email !== null && this.program.notary.email !== '') && (this.program.notary.name !== null && this.program.notary.name !== '') &&
            (this.program.notary.phone !== null && this.program.notary.phone !== '') &&
            (this.program.notary.address !== null && this.program.notary.address !== '') &&
            (this.program.notary.address.line1 !== null && this.program.notary.address.line1 !== '') &&
            (this.program.notary.address.city !== null && this.program.notary.address.city !== '') &&
            (this.program.notary.address.country !== null && this.program.notary.address.country !== '') &&
            (this.program.notary.address.zip_code !== null && this.program.notary.address.zip_code !== '')
        } else {
          return true
        }
      },
      lotChecked () {
        if (!this.lot || !this.adv) return
        if (this.lot.nature === 'parking') {
          return (this.lot.ref !== null && this.lot.ref !== '') &&
          (this.lot.sale_price !== null && this.lot.sale_price !== '') &&
          (this.lot.sale_price_ht !== null && this.lot.sale_price_ht !== '')
        } else if (this.lot.nature === 'field') {
          return (this.adv.sale_price_with_discount !== null && this.adv.sale_price_with_discount !== '')
        } else {
          return (this.lot.floor !== null && this.lot.floor !== '') && (this.lot.surface !== null && this.lot.surface !== '') &&
            (this.lot.lot_type !== null && this.lot.lot_type !== '') &&
            (this.adv.sale_price_with_discount !== null && this.adv.sale_price_with_discount !== '')
        }
      },
      documentChecked () {
        this.contratDeReservationDocuments.forEach(x => {
          if (x.document !== null) {
            if (x.document.cloudinary_id === null && x.document.cloudinary_version === null &&
              x.document.display === null && x.document.filename === null && x.document.fus_id === null && x.document.path === null &&
              x.document.s3_key === null && x.document.s3_path === null) x.document = null
          }
        })
        return !this.contratDeReservationDocuments.find(x => {
          return x.document === null
        })
      },
      buyerChecked () {
        let allBuyers = []
        if (this.coBuyers && this.coBuyers.length) {
          allBuyers = allBuyers.concat(this.coBuyers, this.buyer)
        } else {
          allBuyers.push(this.buyer)
        }
        let checkBuyer = []
        allBuyers.forEach(x => {
          checkBuyer.push(this.checkCompleteBuyerMxn(x))
        })
        return checkBuyer.find(x => {
          if (x === false) return x === false
          return true
        })
      },
      financementChecked () {
        if (!this.adv.use_loan) {
          if (this.adv.security_deposit) {
            return this.adv.security_deposit_value !== null && this.adv.security_deposit_value !== ''
          } else {
            return true
          }
        } else {
          if (this.adv.security_deposit) {
            return this.adv.initial_bank_name !== null && this.adv.initial_bank_name !== '' &&
              this.adv.initial_loan_value !== null && this.adv.initial_loan_value !== '' &&
              this.adv.initial_loan_duration !== null && this.adv.initial_loan_duration !== '' &&
              this.adv.initial_loan_rate !== null && this.adv.initial_loan_rate !== '' &&
              this.adv.security_deposit_value !== null && this.adv.security_deposit_value !== ''
          } else {
            return this.adv.initial_bank_name !== null && this.adv.initial_bank_name !== '' &&
              this.adv.initial_loan_value !== null && this.adv.initial_loan_value !== '' &&
              this.adv.initial_loan_duration !== null && this.adv.initial_loan_duration !== '' &&
              this.adv.initial_loan_rate !== null && this.adv.initial_loan_rate !== ''
          }
        }
      },
      promoteurChecked () {
        if (!this.adv.promoteur_contact) return
        return !isNil(this.adv.promoteur_contact.last_name) && !isNil(this.adv.promoteur_contact.company_name) && !isNil(this.adv.promoteur_contact.first_name) && !isEmpty(this.adv.promoteur_contact.address) &&
          !isNil(this.adv.promoteur_contact.phone) && !isNil(this.adv.promoteur_contact.email)
      },
      canSubmitDossierResa () {
        return this.lotChecked && this.programChecked && this.documentChecked && this.buyerChecked && this.promoteurChecked && this.financementChecked
      },
      currentComment () {
        return this.adv.contrat_de_reservation.comment
      }
    },
    watch: {
      'not_using_loan' (to) {
        if (to === this.adv.use_loan) {
          let adv = Object.assign({}, this.adv)
          adv.use_loan = !to
          this.$emit('commit', adv)
        }
      },
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'CONTACT_SELECTION') {
            results.entities.forEach(x => {
              this.addCoBuyer(x)
            })
          }
        }
      },
      modal ({ mode, params, results }) {
        if (results) {
          if (mode === 'PROMOTEUR_CONTACT') {
            let adv = Object.assign({}, this.adv)
            this.$set(adv, 'promoteur_contact', results)
            this.$emit('commit', adv)
          }
        }
      }
    },
    methods: {
      beforeRemove (val) {
        this.$swal({
          title: 'Acquéreur',
          text: 'Souhaitez-vous vraiment retirer cet acquéreur ?',
          confirmButtonText: 'Oui',
          cancelButtonText: 'Annuler',
          cancelButtonColor: '#ff0200',
          showCloseButton: true
        }).then(res => {
          console.log(res)
          if (res.value) {
            this.DeleteCobuyer(val)
          }
        })
      },
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let wysiElem
          if (!this.adv.contrat_de_reservation.comment && !this.adv.contrat_de_reservation.seller_comment) {
            wysiElem = document.getElementsByClassName('ql-editor ql-blank')
            wysiElem = wysiElem[0]
            wysiElem.setAttribute('contenteditable', 'true')
            wysiElem.focus()
          } else {
            let selection = document.getSelection()
            let range = document.createRange()
            let contenteditable = document.querySelector('div[contenteditable="true"]')

            if (contenteditable.lastChild.nodeType === 3) {
              range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
            } else {
              range.setStart(contenteditable, contenteditable.childNodes.length)
            }
            selection.removeAllRanges()
            selection.addRange(range)
          }
        })
      },
      // getContrat () {
      //   this.loadContrat = true
      //   let url = this.$configs.APIROOT + '/pdf/dossier-de-reservation-light/' + this.advPk + '.pdf'
      //   this.$api.axios.get(url, {
      //     responseType: 'arraybuffer',
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'Accept': 'application/pdf'
      //     }
      //   })
      //   .then(response => {
      //     let urlContrat = window.URL.createObjectURL(new Blob([response.data]), {type: 'application/pdf'})
      //     console.log(urlContrat)
      //     this.$store.commit('setContratDeResa', urlContrat)
      //     this.loadContrat = false
      //     this.openModalDossierDeResa(urlContrat)
      //   })
      //   .catch(error => {
      //     console.log(error)
      //     this.loadContrat = false
      //   })
      // },
      addressContactIsValid (address) {
        if (this.currentUserCountry === 'FRA') {
          return address !== null && address !== '' &&
          address.line1 !== null && address.line1 !== '' &&
          address.zip_code !== null && address.zip_code !== '' &&
          address.city !== null && address.city !== ''
        } else {
          return address !== null && address !== '' &&
            address.zip_code !== null && address.zip_code !== '' &&
            address.city !== null && address.city !== ''
        }
      },
      checkCompleteBuyerMxn (buyer) {
        if (!buyer) return
        if (buyer.nature === 'corporation') {
          return (buyer.corporation_name !== null || buyer.corporation_name !== '') &&
            (buyer.corporation_siret !== null || buyer.corporation_siret !== '') &&
            buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            this.addressContactIsValid(buyer.address) &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '')
        } else {
          return buyer.last_name !== null && buyer.last_name !== '' &&
            buyer.birth_name !== null && buyer.birth_name !== '' &&
            buyer.first_name !== null && buyer.first_name !== '' &&
            this.addressContactIsValid(buyer.address) &&
            buyer.birthday !== null && buyer.birthday !== '' &&
            buyer.nationality !== null && buyer.nationality !== '' &&
            buyer.birthplace !== null && buyer.birthplace !== '' &&
            (buyer.csp === 'unemployed' || buyer.csp === 'retirement'
              ? true : buyer.profession !== null && buyer.profession !== '') &&
            (buyer.family_situation === 'married'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') : true) &&
            (buyer.family_situation === 'pacs'
              ? (buyer.matrimonial_status !== null && buyer.matrimonial_status !== '') : true)
        }
      },
      saveAdv () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv.contrat_de_reservation, 'comment', this.commentaire)
        this.$set(adv.contrat_de_reservation, 'seller_comment', this.seller_commentaire)
        this.$emit('saveAdv', adv)
        this.openWysi = false
      },
      updateDeposit () {
        this.adv.security_deposit = !this.adv.security_deposit
        this.updateAdvFinancement()
      },
      updateLoanValue (val) {
        this.loan_value = val
        if (this.loan_value === '') this.loan_value = null
        this.updateAdvFinancement()
      },
      updateBanqueValue (val) {
        this.adv.initial_bank_name = val
        this.updateAdvFinancement()
      },
      updateLoanDuration (val) {
        this.adv.initial_loan_duration = val
        this.updateAdvFinancement()
      },
      updateLoanRate (val) {
        if (this.loan_rate === '') this.loan_rate = null
        this.updateAdvFinancement()
      },
      updateSecurytyDeposit (val) {
        this.deposit_value = val
        if (this.deposit_value === '') this.deposit_value = null
        this.updateAdvFinancement()
      },
      updateAdvFinancement () {
        let adv = Object.assign({}, this.adv)
        this.$set(adv, 'initial_loan_value', this.loan_value)
        this.$set(adv, 'initial_loan_rate', this.loan_rate)
        this.$set(adv, 'security_deposit_value', this.deposit_value)
        this.$nextTick(() => {
          this.$emit('commit', adv)
        })
      },
      DeleteCobuyer (buyer) {
        remove(this.coBuyers, x => x.pk === buyer.pk)
        let adv = cloneDeep(this.adv)
        adv.co_buyers = this.coBuyers.length ? this.coBuyers.map(x => x.pk) : []
        this.$emit('commit', adv)
      },
      async openModalDossierDeResa () {
        this.loadContrat = true
        let url = this.$configs.APIROOT + '/pdf/reservation-contract-file/' + this.advPk
        let dossierLink = await this.$api.axios.get(url)
        let params = {
          title: 'Dossier de réservation',
          link: dossierLink.data,
          adv: this.adv,
          source: { ...this.adv.pk },
          buyers: this.buyers
        }
        this.$store.commit('setModal', { mode: 'DOSSIER_RESA', params })
        this.loadContrat = false
      },
      goToProgram () {
        let params = {
          name: 'ProgramEdit',
          params: { id: this.program.pk },
          query: { returnAdv: true }
        }
        if (this.currentUserCountry === 'FRA') {
          params.query.check = 1
        }
        this.$router.push(params)
      },
      goToLot () {
        if (this.lot && this.lot.nature === 'parking') {
          this.$router.push({ name: 'ParkingEdit', params: { id: this.lot.pk }, query: { check: 1 } })
        } else {
          this.$router.push({ name: 'LotEdit', params: { id: this.lot.pk }, query: { check: 1 } })
        }
      },
      addCoBuyer (buyer) {
        this.adv.co_buyers.push(buyer.pk)
      },
      removeCoBuyer (buyer) {
        remove(this.adv.co_buyers, x => {
          return x === buyer.pk
        })
      },
      openBuyerSelection () {
        let params = {
          excludes: this.buyersPk
        }
        this.$store.commit('setQuickview', { mode: 'CONTACT_SELECTION', params: params })
      },
      initAccuseDeReception () {
        if (isNil(this.contrat) || isNil(this.contrat.accuse_de_reception) || isEmpty(this.contrat.accuse_de_reception)) {
          return {
            check: false,
            status: 'not_valid',
            dossier_envoyes: null,
            numero_ar: null,
            presentation_ar: null,
            reception_ar: null
          }
        } else if (this.contrat.accuse_de_reception && Array.isArray(this.contrat.accuse_de_reception) && this.contrat.accuse_de_reception.length) {
          return Object.assign({}, this.contrat.accuse_de_reception[0])
        } else {
          return Object.assign({}, this.contrat.accuse_de_reception)
        }
      },
      commitAdv: debounce(function (editedAdv, save = false) {
        let cleanedDocuments = []
        for (let entry of this.contratDeReservationDocuments) {
          if (entry.document && !entry.document.path) {
            entry.document = null
          }
          cleanedDocuments.push(entry)
        }
        let adv = Object.assign({}, this.adv)
        this.$set(adv.contrat_de_reservation, 'accuse_de_reception', this.accuseDeReception)
        this.$set(adv.contrat_de_reservation, 'documents', cleanedDocuments)
        this.$emit('commit', adv, save)
      }, 500),
      updateDebutDeVenteAnnoncee (value) {
        if (isNil(value) || value.length === 0) {
          return
        }
        let date = value[0]
        this.adv.contrat_de_reservation.debut_de_vente_annoncee = moment(date).format('DD/MM/YYYY')
      },
      // clearAdvSignatureDate () {
      //   this.signatureDate = null
      // },
      newReminder (val) {
        let params = {
          source: {
            custom_fields: {
              adv: this.adv.pk,
              adv_ref: this.adv.ref,
              buyer: this.buyer.pk,
              buyer_name: `${this.buyer.last_name} ${this.buyer.first_name}`,
              buyer_info: this.buyer.email && this.buyer.phone ? `${this.buyer.phone} - ${this.buyer.email}` : this.buyer.email || this.buyer.phone
            }
          },
          defaultTitle: val
        }
        this.$store.commit('setQuickview', { mode: 'NEW_REMINDER', params })
      },
      addNewAnnexDocument (item = {}) {
        this.contratDeReservationDocuments.push({
          check: false,
          value: item.value || uuidv4(),
          name: item.name || `Nouveau Document ${this.contratDeReservationDocuments.length + 1}`,
          date: null,
          status: 'not_valid',
          document: item.document || null
        })
        this.commitAdv()
      },
      removeContratDocument (idx) {
        this.contratDeReservationDocuments.splice(idx, 1)
        this.commitAdv()
      }
    },
    created () {
      if (this.adv.contrat_de_reservation.comment) this.commentaire = this.adv.contrat_de_reservation.comment
      if (this.adv.contrat_de_reservation.seller_comment) this.seller_commentaire = this.adv.contrat_de_reservation.seller_comment
      this.not_using_loan = !this.adv.use_loan
      this.accuseDeReception = this.initAccuseDeReception()
      // if (this.adv.signature_date) {
      //   this.signatureDate = moment.utc(this.adv.signature_date).toDate()
      // }
      this.reservationDate = moment.utc(this.adv.reservation_date).format('DD/MM/YYYY')
      // if (this.adv.signature_date) {
      //   this.signatureDate = this.adv.signature_date
      // }
      this.loan_value = this.adv.initial_loan_value
      this.loan_rate = this.adv.initial_loan_rate
      this.deposit_value = this.adv.security_deposit_value
    },
    mounted () {
      if ('reservation' in this.$route.query && this.$refs.reservationinput) {
        this.$refs.reservationinput.$el.nextSibling.focus()
      }
      bus.$on(EVENTS.LINK_SIGNATURE, () => {
        this.$emit('goToSign')
      })
      this.$dragula.$service.eventBus.$on('drop', (args) => {
        this.commitAdv()
      })
    }
  }
</script>

<style>
  .editr--content {
    min-height: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/ContratDeReservation.vue